/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageTabTable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 22H2V2h20zM4 17v3h4v-3zm6 0v3h4v-3zm6 0v3h4v-3zM4 15h4v-3H4zm6 0h4v-3h-4zm6 0h4v-3h-4zM4 10h4V7H4zm6 0h4V7h-4zm6 0h4V7h-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPageTabTable as PageTabTable };
